import { jsx as _jsx } from "react/jsx-runtime";
import { getRectFromElement } from 'libs/positions';
const calculateTriggerPosition = (widgetTrigger) => {
    var _a;
    const triggerPosition = getRectFromElement((_a = widgetTrigger.firstElementChild) !== null && _a !== void 0 ? _a : widgetTrigger);
    let { width } = triggerPosition;
    if (widgetTrigger.childElementCount > 1 && widgetTrigger.lastElementChild !== null) {
        width += getRectFromElement(widgetTrigger.lastElementChild).width;
    }
    return Object.assign(Object.assign({}, triggerPosition), { width });
};
const DocumentWidget = ({ widgetTrigger, WidgetComponent, onClick, editorController, isRightToLeft, disabled, isCaptionMode, className, }) => {
    var _a;
    if (widgetTrigger === null) {
        global.logger.error('No widget trigger found');
        return null;
    }
    const editorElement = (_a = editorController.quill) === null || _a === void 0 ? void 0 : _a.root;
    if (editorElement === undefined) {
        return null;
    }
    const editorPosition = getRectFromElement(editorElement);
    const triggerPosition = calculateTriggerPosition(widgetTrigger);
    const relativePosition = {
        top: triggerPosition.top - editorPosition.top,
        left: triggerPosition.left - editorPosition.left,
        width: triggerPosition.width,
        isRightToLeft,
    };
    return (_jsx(WidgetComponent, { position: relativePosition, widgetTrigger: widgetTrigger, disabled: disabled, onClick: onClick, editorController: editorController, isCaptionMode: isCaptionMode, className: className }));
};
export default DocumentWidget;
